import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { canView } from "../../utils/permissions";
import { message } from "antd";
import {
  getAgentListingApi,
  createAgentApi,
  changeAgentStatusApi,
  changeSelfieStatusApi,
  changeAllSelfieStatusApi,
} from "./agentService";
import CreateAgentModal from "./components/CreateAgentModal";
import AgentTable from "./components/AgentTable";
const Agents = () => {
  const auth = useSelector((state) => state.auth);

  const passwordChange = canView(auth?.mobile);

  const [agents, setAgents] = useState([]);
  const [apiMessage, setApiMessage] = useState("");
  const [apiMessageType, setApiMessageType] = useState("");
  const closeModalRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    password: "",
    selfieMode: false,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (auth?.accessToken) {
      getAgentListing();
    }
  }, [auth?.accessToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};

    if (!formData.name.trim()) {
      validationErrors.name = "Name is mandatory";
    }

    if (!formData.mobile.trim()) {
      validationErrors.mobile = "Mobile Number is mandatory";
    }

    if (!formData.password.trim()) {
      validationErrors.password = "Password is mandatory";
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    try {
      await createAgentApi(formData, auth.accessToken);

      message.success("Agent created successfully!");

      getAgentListing();
      setFormData({
        name: "",
        mobile: "",
        password: "",
        selfie: "",
      });

      setErrors({});
      closeModalRef.current?.click();
    } catch (error) {
      setApiMessage(error.response?.data?.message || "Something went wrong.");
      setApiMessageType("danger");
    }
  };

  const getAgentListing = async () => {
    try {
      const response = await getAgentListingApi(auth.accessToken);
      setAgents(response.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  // ACTIVE - INACTIVE AGENT
  const agentStatus = async (mobile) => {
    try {
      const response = await changeAgentStatusApi(mobile, auth.accessToken);
      // Show success message from API or custom message
      message.success(response.data?.message || "Status changed successfully.");
      // Refresh agent list
      await getAgentListing();
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to change status.",
      );
    }
  };

  // Change Selfie Status
  const changeSelfieStatus = async (mobile) => {
    try {
      const response = await changeSelfieStatusApi(mobile, auth.accessToken);
      // Show success message from API or custom message
      message.success(response.data?.message || "Status changed successfully.");
      // Refresh agent list
      await getAgentListing();
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to change status.",
      );
    }
  };

  // Change All Selfie Status
  const changeAllSelfieStatus = async (status) => {
    try {
      const response = await changeAllSelfieStatusApi(status, auth.accessToken);
      // Show success message from API or custom message
      message.success(response.data?.message || "Status changed successfully.");
      // Refresh agent list
      await getAgentListing();
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to change status.",
      );
    }
  };

  return (
    <>
      <div className="d-flex justify-content-end mb-4">
        <button
          type="button"
          className="btn btn-primary"
          data-toggle="modal"
          data-target="#createAgentModal"
          onClick={() => {
            setApiMessage("");
            setApiMessageType("");
          }}
        >
          Create Agent
        </button>
      </div>

      <CreateAgentModal
        apiMessage={apiMessage}
        apiMessageType={apiMessageType}
        formData={formData}
        errors={errors}
        setFormData={setFormData}
        setErrors={setErrors}
        handleSubmit={handleSubmit}
        closeModalRef={closeModalRef}
      />

      {/* Modal*/}

      <AgentTable
        agents={agents}
        passwordChange={passwordChange}
        agentStatus={agentStatus}
        changeSelfieStatus={changeSelfieStatus}
        changeAllSelfieStatus={changeAllSelfieStatus}
      />
    </>
  );
};

export default Agents;
